module.exports = ["jetzt gerade",["vor %s Sekunde","vor %s Sekunden"],["vor %s Minute","vor %s Minuten"],["vor %s Stunde","vor %s Stunden"],["vor %s Tag","vor %s Tagen"],["vor %s Woche","vor %s Wochen"],["vor %s Monat","vor %s Monaten"],["vor %s Jahr","vor %s Jahren"]]


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-timeago/locales/de-DE.json
// module id = vQ0A
// module chunks = 1